import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import it from './locales/it/translation.json';
import fr from './locales/fr/translation.json';
import tr from './locales/tr/translation.json';
import ar from './locales/ar/translation.json';
import fa from './locales/fa/translation.json';
import pl from './locales/pl/translation.json';
import et from './locales/et/translation.json';
import ro from './locales/ro/translation.json';
import pt from './locales/pt/translation.json';

const resources = {
  en: { translation: en },
  it: { translation: it },
  fr: { translation: fr },
  tr: { translation: tr },
  ar: { translation: ar },
  fa: { translation: fa },
  pl: { translation: pl },
  et: { translation: et },
  ro: { translation: ro },
  pt: { translation: pt }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;
